import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import { Col, Button, Row, Container, Form } from 'react-bootstrap';
import { Tree, TreeNode } from 'react-organizational-chart';
import AuthUtility from "../../util/AuthUtility";
import { CategoryEntity } from "../../dto/category/CategoryEntity";
import { onCategoryList, onCategorySearch } from "../../controller/CategoryController";
import { CategorySearch } from "../../dto/category/CategorySearch";
import { South } from "@mui/icons-material";

const CategoryTree = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!AuthUtility.isUserLoggedIn()) {
        navigate("/login");
        window.location.reload();
    } else {
      categoryListGet();
    }
  }, []);

  const [tops, setTops] = useState<Array<CategoryEntity>>([]);
  const categoryListGet = async () => {
    const response = await onCategoryList(true);
    const beans: Array<CategoryEntity> = response.data.beans;
    if (beans.length > 0) {
      var tree: Array<any> = [];
      for (var i = 0; i < beans.length; i++) {
        console.log('=============');
        await topToBottomNode(beans[i]);
      }
    }
    setTops(beans);
  }

  const topToBottomNode = async (node: CategoryEntity) => {
    var parents: Array<number> = [];
    parents.push(node.id!);
    const search: CategorySearch = {
      parentIds: parents
    }
    const childrens = await onCategorySearch(search);
    if (childrens.status === 0) {
      if (childrens.data.totalElements > 0) {
        var beans: Array<CategoryEntity> = childrens.data.beans;
        if (beans !== undefined) {
          node.childrens! = beans;
        }

        for (var i = 0; i < childrens.data.beans.length; i++) {
          await topToBottomNode(childrens.data.beans[i]);
        }
      }
    }
  }

  var element: React.ReactNode;

  return (
    <Container fluid>
      <div className="overflow-auto">
        <div><Toaster position="top-right" reverseOrder={false}/></div>
        <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Категори мод</h3>
        <Tree
          lineWidth={'2px'}
          lineColor={'green'}
          lineBorderRadius={'10px'}
          label={<div>Root</div>}
        >
          {element}
          {
            tops.map((item, ind) => {
              return (
                <TreeNode key={ind} label={item.name}>
                  {
                    // level 1
                    item.childrens &&
                    item.childrens.length > 0
                    && item.childrens.map((child, childIdx) => {
                      return (
                        <TreeNode key={childIdx} label={child.name}>
                          {
                            // level 2
                            child.childrens &&
                            child.childrens.length > 0
                            && child.childrens.map((child2, child2Idx) => {
                              return (
                                <TreeNode key={child2Idx} label={child2.name}>
                                  {
                                    // level 3
                                    child2.childrens &&
                                    child2.childrens.length > 0
                                    && child2.childrens.map((child3, child3Idx) => {
                                      return (
                                        <TreeNode key={child3Idx} label={child3.name}>
                                          {
                                            // level 4
                                            child3.childrens &&
                                            child3.childrens.length > 0
                                            && child3.childrens.map((child4, child4Idx) => {
                                              return (
                                                <TreeNode key={child4Idx} label={child4.name}>
                                                  {
                                                    // level 5
                                                    child4.childrens &&
                                                    child4.childrens.length > 0
                                                    && child4.childrens.map((child5, child5Idx) => {
                                                      return (
                                                        <TreeNode key={child5Idx} label={child5.name}>
                                                          {
                                                            // level 6
                                                            child5.childrens &&
                                                            child5.childrens.length > 0
                                                            && child5.childrens.map((child6, child6Idx) => {
                                                              return (
                                                                <TreeNode key={child6Idx} label={child6.name}>
                                                                  {
                                                                    // level 7
                                                                    child6.childrens &&
                                                                    child6.childrens.length > 0
                                                                    && child6.childrens.map((child7, child7Idx) => {
                                                                      return (
                                                                        <TreeNode key={child7Idx} label={child7.name}>
                                                                          {
                                                                            // level 8
                                                                            child7.childrens &&
                                                                            child7.childrens.length > 0
                                                                            && child7.childrens.map((child8, child8Idx) => {
                                                                              return (
                                                                                <TreeNode key={child8Idx} label={child8.name}>
                                                                                  {
                                                                                    // level 6
                                                                                  }
                                                                                </TreeNode>
                                                                              )
                                                                            })
                                                                          }
                                                                        </TreeNode>
                                                                      )
                                                                    })
                                                                  }
                                                                </TreeNode>
                                                              )
                                                            })
                                                          }
                                                        </TreeNode>
                                                      )
                                                    })
                                                  }
                                                </TreeNode>
                                              )
                                            })
                                          }
                                        </TreeNode>
                                      )
                                    })
                                  }
                                </TreeNode>
                              )
                            })
                          }
                        </TreeNode>
                      )
                    })
                  }
                </TreeNode>
              )
            })
          }
          {/* <TreeNode label={<div>Child 1</div>}>
            <TreeNode label={<div>Grand Child</div>} />
          </TreeNode>
          <TreeNode label={<div>Child 2</div>}>
            <TreeNode label={<div>Grand Child</div>}>
              <TreeNode label={<div>Great Grand Child 1</div>} />
              <TreeNode label={<div>Great Grand Child 2</div>} />
            </TreeNode>
          </TreeNode>
          <TreeNode label={<div>Child 3</div>}>
            <TreeNode label={<div>Grand Child 1</div>} />
            <TreeNode label={<div>Grand Child 2</div>} />
          </TreeNode> */}
        </Tree>
      </div>
    </Container>
  )
}

export default CategoryTree;